<template>
  <slot></slot>
</template>

<script setup lang="ts">
export interface TabProps {
  id: string | number;
  title: string;
  disabled?: boolean;
}

defineProps<TabProps>();
</script>

<style scoped></style>
